// extracted by mini-css-extract-plugin
module.exports = {"clickableLink":"CbRewardRedemptionModal_clickableLink__4P9og","text":"CbRewardRedemptionModal_text__QkUIq"};